import { FC, HTMLAttributes } from "react"

import { IHiddenValueProps } from './IHiddenValueProps'

interface IHiddenFieldProps extends HTMLAttributes<HTMLInputElement>, IHiddenValueProps {
}

export const SimpleHiddenValue: FC<IHiddenFieldProps> = ({
    id, value
}) => {
    return <>
        <input type='hidden' id={id} value={value} />
    </>
}
